import ReactDOM from 'react-dom';

const renderTo = (comp, container) => {
  ReactDOM.render(comp, container);
};

export default renderTo;
